import React, { lazy, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch, useLocation } from 'react-router-dom';
import AuthWrapper from 'wrappers/AuthWrapper';
import { loadResource } from 'api/resource';
import LoadingScreen from 'components/LoadingScreen';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { LANGUAGE } from 'common';
const Login = lazy(() => import('pages/Login'));
const SignUp = lazy(() => import('pages/SignUp'));
const LoginVerify = lazy(() => import('pages/LoginVerify'));
const ForgotPassword = lazy(() => import('pages/ForgotPassword'));

export default function AppWrapper() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const resource = useQuery('resource', loadResource);
  const initialFilter: any = queryString?.parse(location?.search);
  const host = window.location.host;
  const checkLanguage = [
    'caliente-jp.site',
    'dev.caliente-jp.site',
  ].includes(host);
  useEffect(() => {
    if (checkLanguage) {
      i18n.changeLanguage(LANGUAGE.EN);
      return;
    }
    i18n.changeLanguage(initialFilter?.language || LANGUAGE.JA);
  }, []);
  if (!resource?.data?.data) return <LoadingScreen />;
  return (
    <>
      <div className={`${location.pathname !== '/' ? 'root-wrapper auth-wrapper' : ''}`}>
        <Helmet>
          {checkLanguage ? (
            <link rel="icon" href="/lp-foreign/favicon.ico" />
          ) : (
            <link rel="icon" href="/lp/favicon.ico" />
          )}
        </Helmet>
        <Switch>
          <Route path="/login" exact component={Login} />
          <Route path="/login-verify" exact component={LoginVerify} />
          <Route path="/sign-up/step1" exact component={SignUp} />
          <Route path="/sign-up/step2" exact component={SignUp} />
          <Route path="/sign-up/step3" exact component={SignUp} />
          <Route path="/forgot-password/step1" exact component={ForgotPassword} />
          <Route path="/forgot-password/step2" exact component={ForgotPassword} />
          <Route path="/forgot-password/step3" exact component={ForgotPassword} />
          <Route path="/" component={AuthWrapper} />
        </Switch>
      </div>
    </>
  );
}
